module.exports = __webpack_public_path__ + "components/country-flag/static/ro-84a0a3f5f2f083e2602f9eb994d28a97.svg";